import firebase from 'gatsby-plugin-firebase';

const deleteWPLH = async (id: string): Promise<void> => {
  await firebase.database().ref(`/WPLH/${id}`).remove();
};

export default deleteWPLH;
